import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getAllData = createAsyncThunk(
    'shops/getAllData',
    async ({ lat, lng }) => {
        console.log(lat, lng);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/shops/all-shops`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ lat, lng })
        });
        if (response.ok) {
            const dataObject = await response.json();
            console.log('REDUX dataOBject: ', dataObject);
            return dataObject
        } else {
            const errorResult = await response.json();
            throw new Error(errorResult.message);
        }
    }
)

const shopsSlice = createSlice({
    name: 'shops',
    initialState: {
        data: [],
        fetchStatus: 'idle',
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllData.pending, (state) => {
                state.fetchStatus = 'loading'
            })
            .addCase(getAllData.fulfilled, (state, action) => {
                state.fetchStatus = 'succeeded';
                state.data = action.payload;
            })
            .addCase(getAllData.rejected, (state, action) => {
                state.fetchStatus = 'failed';
                state.error = action.error.message;
            })
    }
})

export default shopsSlice.reducer;